/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Router\HeaderInteractionProvider.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Friday November 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 22nd January 2024 01:54:02
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import UserService from "Services/Users/UserService";
import { createContext, ReactElement, useContext, useEffect, useMemo, useState } from "react";

const setName = (name: string) => {
};
const setRole = (role: string) => {
};

export const UserDataContext = createContext({ Name: "", setName, Role: "", setRole });

export const UserDataProvider = (props: {children: ReactElement<any, any>}) => {
  const [name, setName] = useState<string>("");
  const [role, setRole] = useState<string>("");

  useEffect(() => {
    UserService.getMyProfile().then((val) => {
      setName(`${val.FirstName} ${val.LastName[0]}.`);
      setRole(val.UserRole);
    })
  }, []);

  const value = useMemo(
    () => {
      return {
        Name: name,
        setName,
        Role: role,
        setRole,
    }},
    [name, role]
  );

  return (<UserDataContext.Provider value={value}>{props.children}</UserDataContext.Provider>);
};

export const useUserContext = () => {
  return useContext(UserDataContext);
};
